import { ComponentStyleConfig } from '@chakra-ui/react';

export const Drawer: ComponentStyleConfig = {
	baseStyle: {
		dialog: {
			background: 'gray.100'
		}
	}
};
